module.exports = __webpack_public_path__ + "img/shortcut-bg-2.066cfea2.png";